import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Label } from '@atlas/ui';

const Navigation = ({ activeType, onChange, types }) => {
  if (types.length === 1) {
    return null;
  }

  return (
    <div className="tabs-list">
      {types.map(type => {
        const { title } = type;

        const elementClassName = cx('tab-list-item', {
          active: type === activeType,
        });

        return (
          <div
            className={elementClassName}
            key={title}
            onClick={() => onChange(type)}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onChange(type);
              }
            }}
            role="button"
            tabIndex={0}
          >
            <Label message={title} />
          </div>
        );
      })}
    </div>
  );
};

Navigation.propTypes = {
  activeType: PropTypes.object,
  onChange: PropTypes.func,
  types: PropTypes.arrayOf(PropTypes.object),
};

export default Navigation;
